import { createSelector } from 'reselect'
import * as CardStatusRoles from 'const/CardStatusRoles'

export const getElement = (state, props) => {
  return state['view-card'].elements.elementsById[props.id]
}

export const getIsCardArchived = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isArchived
}

export const getBoardId = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].boardId
}

export const getListId = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].listId
}

export const getCardId = (state, props) => props.cardContext.id

const createChildCountSelector = () => createSelector(
  [
    (state, props) => state['view-card'].elements.elementsById[props.id].items,
    (state, props) => state['view-card'].subCards[props.cardContext.id],
    state => state['view-board'].cards,
    state => state['view-board'].cardStatuses.byId,
  ],
  (
    childIds,
    subCardsById,
    cardsById,
    cardStatusesById,
  ) =>
    childIds
      .filter(childId => {
        const card = cardsById[subCardsById[childId]?.cardId]

        if (!card || card.isArchived) return false

        return cardStatusesById[card.statusId]?.role !== CardStatusRoles.NONE
      })
      .length
)

const createCompletedChildCountSelector = () => createSelector(
  [
    (state, props) => state['view-card'].elements.elementsById[props.id].items,
    (state, props) => state['view-card'].subCards[props.cardContext.id],
    state => state['view-board'].cards,
    state => state['view-board'].cardStatuses.byId,
  ],
  (
    childIds,
    subCardsById,
    cardsById,
    cardStatusesById,
  ) =>
    childIds
      .filter(childId => {
        const card = cardsById[subCardsById[childId]?.cardId]

        if (!card || card.isArchived) return false

        return cardStatusesById[card.statusId]?.role === CardStatusRoles.COMPLETED
      })
      .length
)

const getIsTemplate = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isTemplate
}

export default () => createSelector(
  [
    getElement,
    getIsCardArchived,
    getBoardId,
    getListId,
    getCardId,
    getIsTemplate,
    createChildCountSelector(),
    createCompletedChildCountSelector(),
  ],
  (
    element,
    isCardArchived,
    boardId,
    listId,
    cardId,
    isTemplate,
    childCount,
    completedChildCount
  ) => ({
    isCardArchived,
    items: element.items,
    isBusy: element.isBusy,
    boardId,
    listId,
    cardId,
    isTemplate,
    childCount,
    completedChildCount
  })
)
